module.exports = __webpack_public_path__ + "static/media/slide-conico-mobile.31f4c847.png";